type Data = Record<string, unknown> | string | number

class HiddinEntetiesSelect {
	private readonly fullData = new Map<string, Data[]>()

	setData = (fieldName: string, items: Data[]) => {
		this.fullData.set(fieldName, items)
	}

	getData = (fieldName: string) => {
		return this.fullData.get(fieldName) ?? []
	}

	clear = () => {
		this.fullData.clear()
	}
}

export const hiddinEntetiesSelect = new HiddinEntetiesSelect()
